export const setTokenLocalStorage = (token: string | null) => {
  if (token === null) {
    localStorage.removeItem("token");
    return;
  }

  localStorage.setItem("token", JSON.stringify(token));
};

export const getTokenLocalStorage = (): string | null => {
  const token = localStorage.getItem("token");

  if (!token) return null;

  try {
    return JSON.parse(token);
  } catch {
    return null;
  }
};
